import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router';
import { Redirect } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import '../../App.css';
import { api } from '../../api/create-api';
import { makeCall } from '../../auth-utils';
import { Home } from '../Home';
import { Layout } from '../Shared/Layout';
import { Title } from '../Title';
import { LoginModal } from '../LoginModal';
import { Callback } from '../Shared/Callback';
import { Embed } from '../Inquiries/Embed';
import { Users } from '../Users/Users';
import Logout from '../Logout';
import NoAccess from '../Shared/NoAccess';
import { Properties } from '../Properties/Properties';
import { Topics } from '../Topics/Topics';
import { Inquiries } from '../Inquiries/Inquiries';
import { Reports } from '../Reports';

export const AppName = "Resource Center";
export const AppAbbreviation = "SRC";

export const Admin = (props) => {
    const ls = require('local-storage');
    const [redirect, setRedirect] = useState('');
    const [noAccess, setNoAccess] = useState(true);
    const [unableToConnect, setUnableToConnect] = useState('');
    const [user, setUser] = useState(null);
    const [access, setAccess] = useState(null);
    const [userName, setUserName] = useState(null);
    const [showPrimaryMenu, setShowPrimaryMenu] = useState(true);
    const [loggingInMessage, setLoggingInMessage] = useState(null);
    const [errorGettingUser, setErrorGettingUser] = useState(false);
    const isCallback = window.location.pathname === '/aad-callback';

    useEffect(() => {
        getUser();
    }, []);

    const getUser = async (callback) => {
        makeCall(async (authHeader) => {
            const results = await api({
                url: 'api/users/current?role=user',
                method: 'get',
                headers: { ...authHeader }
            })
                .catch((error) => {
                    setUnableToConnect(error.response.data);
                    setErrorGettingUser(true);
                });

            if (results && results.data) {
                setLoggingInMessage(null);
                if (results.data.role) {
                    ls('user-role', results.data.role);
                    if (typeof callback === "function") {
                        callback();
                    }
                    setAccess(results.data.role);
                    setNoAccess(false);
                }

                setUser(results.data);
            }
        });
    };

    return (
        <Layout CurrentUser={user} Access={access} ShowPrimaryMenu={showPrimaryMenu}>
            <Title title={AppName} AppName={AppName} />
            <LoginModal ModalOpen={!user} ShowRetry={errorGettingUser} Retry={() => {
                setErrorGettingUser(false);
                getUser();
            }} Timeout={isCallback ? 0 : 1000} />
            {!noAccess ?
                <Switch>
                    <Route exact path='/admin' render={(props) => <Home {...props} CurrentUser={user} Access={access} LoginMessage={loggingInMessage} />} />
                    <Route exact path='/admin/embed' render={(props) => <Embed {...props} CurrentUser={user} Access={access} />} />
                    <Route exact path='/admin/inquiries' render={(props) => <Inquiries {...props} CurrentUser={user} Access={access} />} />
                    <Route exact path='/admin/properties' render={(props) => <Properties {...props} CurrentUser={user} Access={access} />} />
                    <Route exact path='/admin/topics' render={(props) => <Topics {...props} CurrentUser={user} Access={access} />} />
                    <Route exact path='/admin/users' render={(props) => <Users {...props} CurrentUser={user} Access={access} />} />
                    <Route exact path='/admin/users/search/:search?' render={(props) => <Users {...props} CurrentUser={user} Access={access} />} />
                    <Route exact path='/admin/reports' render={(props) => <Reports {...props} CurrentUser={user} Access={access} />} />
                    <Route path='*' render={() => <Redirect to='/admin' replace />} />
                </Switch>
                : unableToConnect ?
                    <Row>
                        <Col lg="10" xl="8" className="text-center text-md-start">
                            <div className="border-secondary pb-0 mb-2" style={{ borderBottomWidth: 2, borderBottomStyle: 'solid' }}>
                                <h3 className="d-none d-sm-inline-block d-md-none">{AppName}</h3>
                                <h2 className="d-inline-block d-sm-none d-md-inline-block">{AppName}</h2>
                            </div>
                            <p className="text-dark"><em>{unableToConnect}</em></p>
                        </Col>
                    </Row>
                    : <NoAccess {...props} UserName={userName} CurrentUser={user} />}
        </Layout>
    );
};

//export default App;


// WEBPACK FOOTER //
// ./src/components/Admin/Admin.js